import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {ThemeProps, RTLProps} from '@/shared/prop-types/ReducerProps';
import {Modal, ModalHeader, ModalBody, Row, Col, Button, ButtonToolbar, Input} from 'reactstrap';
import CreatableSelect from "react-select/creatable";
import axios from "axios";
import {useDispatch, sendFlashMessage} from "@/shared/components/flash";
import Dropzone from 'react-dropzone-uploader'
import './style.scss'
import {isEmpty} from '@/shared/helpers'
import {Field, Form} from "react-final-form";
import TrashIcon from 'mdi-react/TrashOutlineIcon';
import { SortableContainer, SortableElement, arrayMove } from "react-sortable-hoc";
import DeleteMediaTypeModal from './DeleteMediaTypeModal';

const fileTypes = [
  'application/pdf',
  'application/msword',
  'application/vnd.ms-word.document.macroEnabled.12',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.ms-excel.sheet.macroEnabled.12',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'application/vnd.ms-excel.sheet.macroEnabled.12',
  'application/msexcel',
  'application/x-msexcel',
  'application/x-ms-excel',
  'application/x-excel',
  'application/x-dos_ms_excel',
  'application/xls',
  'application/x-xls',
  'application/x-msi',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'text/plain',
  'text/xml',
  'application/xml',
  'text/html',
  'application/rtf',
  'text/csv',
  'application/x-afp',
  'image/*',
  'audio/*',
  'video/*',
];

const SortableItem = SortableElement(({ file, index, removeFile }) => (
  <div className="dropzone__img" key={file.name} style={{
    border: '1px solid grey',
    width: `125px`,
    backgroundImage: `url(${process.env.REACT_APP_API_STORAGE_URL + '/' + file.icon_path})`
  }}>
    <p className="dropzone__img-name">{file.name}</p>
    <button className="dropzone__img-delete" type="button" onClick={(e) => removeFile(index, file, e)}>
      Remove
    </button>
  </div>
));

const SortableList = SortableContainer(({ media, removeFile }) => {
  return (
    <div className="dropzone__imgs-wrapper">
      {media.map((file, index) => (
        <SortableItem key={file.name} index={index} file={file} removeFile={removeFile} />
      ))}
    </div>
  );
});

const DigitalMediaModal = ({organization, isOpen, setOpen, toggle, program, theme, rtl}) => {
  const [trigger, setTrigger] = useState(0);
  const [isDeleted, setIsDeleted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false)
  const [media, setMedia] = useState([]);
  const [mediaTypes, setMediaTypes] = useState([]);
  const [mediaType, setMediaType] = useState('');
  const [currentMedia, setCurrentMedia] = useState(null);
  const [uploadedMeta, setUploadedMeta] = useState({});
  const [iconMeta, setIconMeta] = useState({});
  const [fileName, setFileName] = React.useState("");
  let [dropZoneKey, setDropZoneKey] = useState(0);
  const [tab, setTab] = useState(1);
  const [link, setLink] = useState("");
  const [tempLink, setTempLink] = useState()
  const [menuItems, setMenuItems] = useState([]);
  const [currentMenuItem, setCurrentMenuItem] = useState();
  const [currentForm, setCurrentForm] = useState(null);
  const MAX_SIZE = 10485760
  const [uploadError, setUploadError] = useState({})
  const [delCategory, setDelCategory] = useState(null)
  const [isDeleteCategoryOpen, setDeleteCategoryOpen] = useState(false);

  const handleSortEnd = ({ oldIndex, newIndex }) => {
    setMedia((prevMedia) => arrayMove(prevMedia, oldIndex, newIndex));
  };

  const loadMediTypes = async () => {
    try {
      const response = await axios.get(`/organization/${organization.id}/program/${program.id}/digital-media-type`);
      if (response.data.length === 0) return {results: [], count: 0}
      let options = [];
      let menuItems = [];
      response.data.map(row => {
        if (row.is_menu_item === 1) {
          menuItems.push({
            value: row.program_media_type_id,
            url: row.menu_link,
            id: row.program_media_type_id,
            menu_link:row.menu_link,
            label: row.name
          })
        }
        else {
          options.push({
            value: row.program_media_type_id,
            label: row.name
          });
        }
      })
      setMediaTypes(options);
      setMenuItems(menuItems);      
    } catch (e) {
      throw new Error(`API error:${e?.message}`);
    }
  }

  const handleChangeMedia = (value) =>{
    if(value){
      setCurrentMedia(value)
      getData(value.value)
    }
    else{
      setCurrentMedia(null)
      setMedia([])
    }
  }

  const handleChangeForms = (form) =>{
    if(form){
      setCurrentForm(form)
      getIframe(form.value)
    }
    else{
      setCurrentForm(null)
      setTempLink(null)
      setLink('')
    }
  }

  const getData = async (media_type) => {
    const url = axios.defaults.baseURL + `/organization/${organization.id}/program/${program.id}/media/${media_type}`;
    try {
      const response = await axios.get(url);
      const data = response.data;
      setMediaType(media_type);
      setMedia(data);
      return data;
    } catch (e) {
      throw new Error(`API error:${e?.message}`);
    }
  }

  const getIframe = (value) => {    
    let temp = menuItems.filter(iframe =>  iframe.id === value)[0];    
    setCurrentMenuItem(temp); 
    setLink(temp.menu_link || "")
    setTempLink(temp.menu_link || null);
    getData(temp.id);
  }

  useEffect(() => {
    loadMediTypes();
  }, []);

  const getUploadParams = ({meta}) => { 
    const headers = {
      'Authorization': axios.defaults.headers.common['Authorization'],
    }
    const fields = {'fileId': meta.id}
    return {
      url: axios.defaults.baseURL + `/organization/${organization.id}/program/${program.id}/digital-media/upload`,
      headers,
      fields
    }
  }

  const removeFile = (index, file, e) => {
    e.preventDefault();
    const response = axios.delete(
      `/organization/${organization.id}/program/${program.id}/programMedia/${file.id}/digital-media`
    );
    const items = media.filter(item => item.id != file.id);
    setMedia(items);
  };

  useEffect(() => {
    if (isDeleted) {
      loadMediTypes();
      setCurrentMedia(null);
      setIsDeleted(false);
    }
  }, [isDeleted]);

  const onSubmit = values => {
    let saveUrl = `/organization/${organization.id}/program/${program.id}/digital-media`;
    setLoading(true);
    let data = new FormData();
    data.append('file', JSON.stringify(uploadedMeta))
    data.append('icon', JSON.stringify(iconMeta))
    data.append('name', fileName)
    data.append('mediaType', mediaType)

    axios.post(saveUrl, data)
      .then((res) => {
        // console.log(res)
        if (res.status === 200) {
            //dispatch(sendFlashMessage('Media successfully published', 'alert-success'));
            getData(mediaType);
            setUploadedMeta({})
            setIconMeta({})
            setFileName('');
            dropZoneKey++;
            setDropZoneKey( dropZoneKey );

        }
        setLoading(false)
      })
      .catch(error => {
        dispatch(sendFlashMessage(JSON.stringify(error.response.data.errors), 'alert-danger'))
        setLoading(false)
        throw new Error(`API error:${error?.message}`);
      })
  }

  const saveLinkForIframe = (newLink) => {
    let saveUrl = axios.defaults.baseURL +  `/organization/${organization.id}/program/${program.id}/digital-media-type-iframe`;
    let data = new FormData();
    setLoading(true)
    data.append('program_media_type_id', currentMenuItem.id)
    if(newLink){
      data.append('menu_link', newLink);
    }
    
    axios.post(saveUrl, data)
      .then((res) => {
        if (res.status === 200) {
          let menuItem = {
            value: res.data.program_media_type_id,
            url: res.data.menu_link,
            id: res.data.program_media_type_id,
            menu_link:res.data.menu_link,
            label: res.data.name
          }
          setCurrentMenuItem(menuItem)
          loadMediTypes();
          if(!res.data.menu_link){
            setTempLink(null)
            setLink("")
          }
        }
        setLoading(false)
      })
      .catch(error => {
        dispatch(sendFlashMessage(JSON.stringify(error.response.data.errors), 'alert-danger'))
        setLoading(false)
        throw new Error(`API error:${error?.message}`);
      });
  }

  const selectCreateIframe = (inputValue) => {

    setIsLoading(true);
    let saveUrl = axios.defaults.baseURL +  `/organization/${organization.id}/program/${program.id}/digital-media-type`;

    let data = new FormData();
    data.append('name', inputValue);
    data.append('is_menu_item', 1);
    
    axios.post(saveUrl, data)
      .then((res) => {
        // console.log(res)
        if (res.status === 200) {
          setCurrentForm({
            value: res.data.program_media_type_id,
            label: res.data.name
          })
          let newMenuItem = {
            value: res.data.program_media_type_id,
            url: res.data.menu_link,
            id: res.data.program_media_type_id,
            menu_link:res.data.menu_link,
            label: res.data.name
          }
          setCurrentMenuItem(newMenuItem)
          setLink('')
          setTempLink(null)
          loadMediTypes();
        }
        setIsLoading(false)
      })
      .catch(error => {
        dispatch(sendFlashMessage(JSON.stringify(error.response.data.errors), 'alert-danger'))
        setIsLoading(false)
        throw new Error(`API error:${error?.message}`);
      });
  }

  const validate = values => {    
    let errors = {}
    if (!currentMedia){
      errors.category = 'The category field is required.';
    }
    if (isEmpty(iconMeta)){
      errors.icon_upload = 'The preview image field is required.';
    }
    if (isEmpty(uploadedMeta)){
      // setUploadError(prevError => ({ ...prevError, file: null }));
      errors.media_upload = 'The file field is required.';
    }
    if (!fileName){
      errors.fileName = 'The file name field is required.';
    }
    return errors
  }

  const modalProps = {
    isOpen, toggle, setOpen
  }

  const handleChangeStatus = ({meta, file}, status) => {
    
    if (status === 'done') {
      let name = meta.name.substr(0, meta.name.lastIndexOf('.'));
      if (!fileName || fileName !== name) {
        setFileName(name);
      }
      setUploadedMeta(meta);
      setUploadError(prevError => ({ ...prevError, file: null }));
    }
    if (status === "error_file_size"){
      setUploadError(prevError => ({ ...prevError, file: "File is too big" }));
    }
    if(status === 'removed'){
      setFileName('');
      setUploadedMeta({});
      setUploadError(prevError => ({ ...prevError, file: null }));
    }
    if(status === 'error_upload'){
      setUploadError(prevError => ({ ...prevError, file: "Upload error" }));
    }
  }

  const handleUploadIcon = ({meta, file}, status) => {
    if (status === 'done') {
      setIconMeta(meta);
      setUploadError(prevError => ({ ...prevError, icon: null }));
    }
    if (status === "error_file_size"){
      setUploadError(prevError => ({ ...prevError, icon: "File is too big" }));
    }
    if(status === 'removed'){
      setIconMeta({});
      setUploadError(prevError => ({ ...prevError, icon: null }));
    }
    if(status === 'error_upload'){
      setUploadError(prevError => ({ ...prevError, icon: "Upload error" }));
    }
  }

  const onChangeFileName = (event) => {
    setFileName(event.target.value);
  }

  const onChangeLinkUrl = (event) => {
    setLink(event.target.value)
  }

  const selectCreateOption = (inputValue) => {
  
    let saveUrl = axios.defaults.baseURL +  `/organization/${organization.id}/program/${program.id}/digital-media-type`;

    let data = new FormData();
    data.append('name', inputValue);
    data.append('is_menu_item', 0);
    
    axios.post(saveUrl, data)
      .then((res) => {        
        if (res.status === 200) {
          loadMediTypes();
          setMedia([]);
          setMediaType(res.data.program_media_type_id)
          setCurrentMedia({
            value: res.data.program_media_type_id,
            label: res.data.name
          })
        }
        setIsLoading(false)
      })
      .catch(error => {
        dispatch(sendFlashMessage(JSON.stringify(error.response.data.errors), 'alert-danger'))
        setIsLoading(false)
        throw new Error(`API error:${error?.message}`);
      });
  }

  const addMenus = () => {
    if (link !== "") {      
      setTempLink(link); 
    }
  
  }

  const deleteMenu = () =>{
    //const response = 
    axios.delete(
      `/organization/${organization.id}/program/${program.id}/digital-media-type/${currentMenuItem.id}`
    ).then((res) => {        
      if (res.status === 200) {
        loadMediTypes();
        setCurrentForm(null)
        setTempLink(null)
      }
    })
    .catch(error => {
      dispatch(sendFlashMessage(JSON.stringify(error.response.data.errors), 'alert-danger'))
      setLoading(false)
      throw new Error(`API error:${error?.message}`);
    });    
  }

  const setMediaTab = () => {
    if(tab !== 1){
      setTempLink(null)
      setLink('')
      setTab(1);
      setUploadError({});
      setCurrentForm(null)
    }
  }

  const setFormsTab = () => {
    if(tab !== 2){
      setMedia([])
      setTab(2);
      setCurrentMedia(null)
      setFileName('')
      setIconMeta({})
      setUploadedMeta({})
    }
  }

  function toTitleCase(str) {
    return str.toLowerCase().replace(/(?:^|\s)\w/g, function(match) {
      return match.toUpperCase();
    })
  }

  const updatePosition = () => {
    const updatedMedia = media.map((file, index) => ({
        ...file,
        position: index + 1
    }));

    console.log('Updated media:', updatedMedia);

    let updateUrl = `/organization/${organization.id}/program/${program.id}/update-digital-media-position`;
    setLoading(true);

    axios.post(updateUrl, {media: updatedMedia})
      .then((res) => {
        if (res.status === 200) {
            dispatch(sendFlashMessage('Media successfully updated', 'alert-success'));
        }
        setLoading(false);
      })
      .catch(error => {
        console.log(JSON.stringify(error.response.data.errors));
        dispatch(sendFlashMessage(JSON.stringify(error.response.data.errors), 'alert-danger'));
        setLoading(false);
        throw new Error(`API error:${error?.message}`);
      });
  }
  const toggleDeleteCategory = () => {
    setDeleteCategoryOpen(prevState => !prevState)
}
  const onClickDeletePopup = () => {
    setDelCategory({ currentMedia });
    toggleDeleteCategory()
  }
  return (
    <Modal className={`modal-program manager-program-modal manager-program-modal--wide modal-lg ${theme.className} ${rtl.direction}-support`} {...modalProps}>
      <ModalHeader tag="div" className="manager-program-modal__header">
        <div className="manager-program-modal__header-row">
          <div className="manager-program-modal__header-copy">
            <h3 className="manager-program-modal__title">Digital Media</h3>
            <p className="manager-program-modal__subtitle">
              Manage uploaded assets and form links for {program.name}.
            </p>
          </div>
          <ButtonToolbar className="manager-program-modal__actions">
            <Button outline color="primary" onClick={toggle}>Close</Button>
          </ButtonToolbar>
        </div>
      </ModalHeader>
      <ModalBody className="manager-program-modal__body">
        <div className="manager-program-modal__segmented" role="tablist" aria-label="Digital media sections">
          <button
            type="button"
            className={`manager-program-modal__segmented-btn${tab === 1 ? ' is-active' : ''}`}
            onClick={setMediaTab}
          >
            Media
          </button>
          <button
            type="button"
            className={`manager-program-modal__segmented-btn${tab === 2 ? ' is-active' : ''}`}
            onClick={setFormsTab}
          >
            Forms
          </button>
        </div>
        <div className="manager-program-modal__content-card">
              {tab === 1 ?
                <Form
                  onSubmit={onSubmit}
                  validate={validate}
                  render={({handleSubmit, form, submitting, pristine, values}) => (
                    <form className="form" onSubmit={handleSubmit}>
                      <Row>
                        <Col md="12">
                            <div>
                              <Field name="category">
                                {({ input, meta }) => (
                                  <div className="form__form-group">
                                    <div className="form__form-group-field">
                                      <div className="form__form-group-row" style={{position: '', marginTop: '0px', textTransform:"capitalize", zIndex: 100}}>
                                        <CreatableSelect
                                          name="category"
                                          isClearable
                                          isDisabled={isLoading}
                                          isLoading={isLoading}
                                          options={mediaTypes}
                                          onCreateOption={selectCreateOption}
                                          placeholder='Select or Create a Menu Category'
                                          onChange={ handleChangeMedia }
                                          value={currentMedia}
                                        />
                                        {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </Field>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="4">
                          <Field name="icon_upload">
                            {({input, meta}) => (
                              <div className="form__form-group">
                                <div className="form__form-group-field  flex-column" style={{position: '', marginTop: '0px'}}>
                                  <Dropzone 
                                    key={dropZoneKey}
                                    getUploadParams={getUploadParams}
                                    accept="image/jpeg, image/png, image/gif"
                                    //accept="image/*,audio/*,video/*"
                                    name="icon_upload"
                                    inputContent="Select Preview Image"
                                    maxFiles={1}
                                    maxSizeBytes ={MAX_SIZE}    
                                    onSubmit={false}
                                    onChangeStatus={handleUploadIcon}
                                  />
                                  {meta.touched && meta.error && !uploadError.icon && <span className="form__form-group-error">{meta.error}</span>}
                                  {uploadError && uploadError.icon && <p className="form__form-group-error">{ uploadError.icon }</p>}
                                </div>
                              </div>
                              )}
                          </Field>
                        </Col>
                        <Col md="4">
                          <Field name='media_upload'>
                            {({input, meta}) => (
                              <div className="form__form-group">
                                <div className="form__form-group-field  flex-column" style={{position: '', marginTop: '0px'}}>
                                  <Dropzone key={dropZoneKey}
                                    getUploadParams={getUploadParams}
                                    accept={fileTypes.join(',')}
                                    name="media_upload"
                                    inputContent="Select File"
                                    maxFiles={1}
                                    onSubmit={false}
                                    maxSizeBytes ={MAX_SIZE}
                                    onChangeStatus={handleChangeStatus}
                                  />
                                </div>
                                {meta.touched && meta.error && !uploadError.file && <span className="form__form-group-error">{meta.error}</span>}
                                {uploadError && uploadError.file && <p className="form__form-group-error">{ uploadError.file }</p>}
                              </div>
                            )}
                          </Field>
                        </Col>
         
                        <Col md="4">
                          <div>
                            <Field name="fileName">
                              {({input, meta}) => (
                                <div className="form__form-group">
                                  <span className="form__form-group-label">Enter File Name </span>
                                  <div>
                                    <Input 
                                       name='fileName'
                                      style={{borderWidth: 1, borderColor: 'gray'}}
                                      type="text" value={fileName}
                                      placeholder="File Name"
                                      onChange={onChangeFileName} 
                                    />
                                    
                                    {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                  </div>
                                </div>
                              )}
                            </Field>
                          </div>
                          {currentMedia && <div>
                          <Button 
                            className="btn btn-danger" 
                            onClick={() => onClickDeletePopup()} 
                            color="#ffffff"
                          >
                            Delete category
                          </Button>
                          </div>}
                        </Col>
                      </Row>
                      {delCategory && <DeleteMediaTypeModal 
                        isOpen={isDeleteCategoryOpen} 
                        setOpen={setDeleteCategoryOpen} 
                        toggle={toggleDeleteCategory} 
                        program={program} 
                        category={currentMedia} 
                        setTrigger={setTrigger} 
                        setIsDeleted={setIsDeleted}
                      />}
                      <Row>
                        <Col>
                          <div>
                            <Button type="submit" disabled={loading} className="btn btn-primary" color="#ffffff">Save</Button>
                          </div>
                        </Col>
                      </Row>

                    </form>
                  )}
                />
                 :                 
                  <>
                      <Row>
                        <Col md="12">
                          <div className="form__form-group">
                            <div className="form__form-group-field  flex-column" style={{position: '', marginTop: '0px', textTransform:"capitalize"}}>
                              <CreatableSelect
                                  name="category"
                                  isClearable
                                  isDisabled={isLoading}
                                  isLoading={isLoading}
                                  options={menuItems}
                                  onCreateOption={selectCreateIframe}
                                  placeholder='Select or Create a Menu Category'
                                  onChange={ handleChangeForms }
                                  value={ currentForm }
                                />

                            </div>
                          </div>
                          { currentForm && 
                          <div className="form__form-group">
                            <span className="form__form-group-label">Link </span>
                              <div className='table-filter-form form row'>
                                <div className='col-sm-4 col-md-4 col-lg-4'>
                                  <input onChange={onChangeLinkUrl}
                                      style={{borderWidth: 1, borderColor: 'gray', maxWidth:'200px'}}
                                      type="text" value={link}
                                      placeholder="Link Url"/>
                                </div>
                                <div className='col-sm-4 col-md-4 col-lg-4 d-flex justify-content-end'>      
                                  <Button  color="primary" disabled={!link || link === tempLink} className="" onClick={()=>addMenus()}>{!tempLink ? "Add" : "Update"}</Button>
                                </div>
                                <div className='col-sm-4 col-md-4 col-lg-4 d-flex justify-content-end'>      
                                  <div className="pointer" onClick={(e) => { if (window.confirm('Are you sure to delete this menu?')) { deleteMenu() } }}>
                                    <TrashIcon color='#777777' />
                                  </div>
                                </div>
                              </div>
                          </div>
                          }
                        </Col>
                      </Row>
                      { tempLink && 
                        <Row>
                          <Col md="12">
                            <div className='form__form-group'>
                              <div className='table-filter-form form row'>
                                  <div className='col-sm-8 col-md-8 col-lg-8'>
                                      <h4>{tempLink}</h4>
                                  </div>
                                  <div className='col-4 d-flex justify-content-end'>      
                                    <Button  color="primary" disabled={!currentMenuItem?.menu_link} className="" onClick={()=> { if(window.confirm('Are you sure to remove this link from the menu?')){saveLinkForIframe()}} }>Remove</Button>
                                  </div>
                                </div>
                            </div>
                          </Col>
                        </Row>
                      }
                      <Row>
                        <Col>
                          <div>
                            <Button onClick={() =>saveLinkForIframe(tempLink)} disabled={loading || !currentMenuItem || currentMenuItem?.menu_link == tempLink} className="btn btn-primary"
                                    color="#ffffff">Save</Button>
                          </div>
                        </Col>
                      </Row>
                  </>
              }
        </div>
              <Row>
                <Col>
                  {media && media.length > 0
                    && (
                      <div className="manager-program-modal__content-card manager-program-modal__content-card--muted">
                      <SortableList media={media} removeFile={removeFile} onSortEnd={handleSortEnd} axis="xy" />
                      <div className="manager-program-modal__content-card-actions">
                        <div>
                          <Button onClick={updatePosition} disabled={loading} className="btn btn-primary" color="#ffffff">Update Positions</Button>
                        </div>
                      </div>
                      </div>
                    )}
                </Col>
              </Row>
      </ModalBody>
    </Modal>
  )
}

const RenderImage = ({src}) => {
  if (!src || typeof src === 'undefined') return ''
  return (
    <div className='dropzone-img'>
      <a href={src} target='_blank' rel="noreferrer" title='View the picture'>
        <img style={{maxHeight: 200}} src={src}/>
      </a>
    </div>
  )
}



DigitalMediaModal.propTypes = {
  theme: ThemeProps.isRequired,
  rtl: RTLProps.isRequired,
  organization: Object.isRequired,
  data: Object.isRequired
};

export default (connect((state) => ({
  theme: state.theme,
  rtl: state.rtl,
  organization: state.organization,
  program: state.program
}))(DigitalMediaModal));
